// Generated by CoffeeScript 1.12.4
(function() {
  var Eidolon, defaultValue, dereference, generateExample, generateSchema, inherit;

  defaultValue = require('./default-value');

  dereference = require('./dereference');

  generateExample = require('./example');

  generateSchema = require('./schema');

  inherit = require('./inherit').inherit;

  Eidolon = (function() {
    function Eidolon(structures, options1) {
      var base;
      this.structures = structures != null ? structures : {};
      this.options = options1 != null ? options1 : {};
      if ((base = this.options).defaultValue == null) {
        base.defaultValue = defaultValue;
      }
    }

    Eidolon.prototype.dereference = function(element) {
      return dereference(element, this.structures);
    };

    Eidolon.prototype.example = function(element, options) {
      if (options == null) {
        options = this.options;
      }
      return generateExample(element, this.structures, options);
    };

    Eidolon.prototype.schema = function(element) {
      return generateSchema(element, this.structures);
    };

    return Eidolon;

  })();

  module.exports = {
    Eidolon: Eidolon,
    defaultValue: defaultValue,
    dereference: dereference,
    example: generateExample,
    inherit: inherit,
    schema: generateSchema
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/eidolon/lib/eidolon.js
// module id = 121
// module chunks = 0